<template>
    <BootstrapModal
      ref="modal"
      modalId="copyTemplateModal"
      title="Confirm Copy Template"
      closeText="Cancel"
      :body="copyMessage"
      @confirm="handleConfirm"
    />
  </template>
  
  <script>
  import BootstrapModal from "@/components/Common/BootstrapModal.vue";
  import templateService from "@/services/templateService.js";
  import emitter from "@/eventBus";
  
  export default {
    name: "DeleteTemplateModal",
    components: { BootstrapModal },
    props: {
      template: {
        type: Object,
        required: false,
        default: null,
      },
    },
    emits: ["deleted"],
    computed: {
      copyMessage() {
        if (!this.template) {
            return null;
        }

        return `Are you sure you want to copy template <b>#${this.template.id} (${this.template.name})</b>?`;
      },
    },
    methods: {
      show() {
        this.$refs.modal.show();
      },
      hide() {
        this.$refs.modal.hide();
      },
      async handleConfirm() {
        if (!this.template?.id) return;
  
        try {
          await templateService.copyTemplate(this.template.id);
          emitter.emit("show-toast", {
            message: `Template #${this.template.id} copied successfully.`,
            type: "success",
          });
          this.$emit("copied", this.template.id);
        } catch (error) {
          console.error(error);
        }
  
        this.hide();
      },
    },
  };
  </script>
  